import { render, staticRenderFns } from "./ProjectRealEstateEagleCRM.vue?vue&type=template&id=3dfe15c5"
import script from "./ProjectRealEstateEagleCRM.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstateEagleCRM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports